
import React from 'react';
import { LucideIcon } from 'lucide-react';

interface ContactInfoCardProps {
  icon: LucideIcon;
  title: string;
  content: string;
  link?: string;
  index: number;
}

const ContactInfoCard: React.FC<ContactInfoCardProps> = ({ 
  icon: IconComponent, 
  title, 
  content, 
  link, 
  index 
}) => {
  const CardContent = (
    <div className="bg-white rounded-2xl p-6 shadow-elegant hover:shadow-elegant-lg hover:-translate-y-1 transition-all duration-300 group border border-gray-100">
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <div className="w-12 h-12 bg-primary-brand rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
            <IconComponent className="w-6 h-6 text-white" />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-primary-brand text-lg mb-2">{title}</h3>
          <div className="text-gray-600 leading-relaxed whitespace-pre-line">
            {content}
          </div>
        </div>
      </div>
    </div>
  );

  return link ? (
    <a
      href={link}
      className="block hover:no-underline"
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      {CardContent}
    </a>
  ) : (
    <div style={{ animationDelay: `${index * 0.1}s` }}>
      {CardContent}
    </div>
  );
};

export default ContactInfoCard;
